<template>
  <div>
    <headerTop></headerTop>
    <div class="wrapper">
      <!-- 极配正品 -->
      <!-- <div class="header">
        <img src="@/assets/images/home/logo.png" class="logo" alt="" />
        <div style="position: relative;">
          <div style=" position: absolute;bottom: 0;right: 0; width: 135px;">
            正见 &nbsp; •&nbsp;&nbsp;正心&nbsp; •&nbsp;&nbsp;正品
          </div>
        </div>
      </div> -->
      <div class="content_button">
        <!-- 进度 -->
        <div class="flow">
          <div class="flowcontent">
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-zu5361"></i> -->
                <img src="@/assets/images/refund/组 706.png" alt="" />
              </div>
              <div>买家申请售后</div>
            </div>
            <img class="img1" src="@/assets/images/refund/组 1613.png" alt="" />
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-ziyuan35"></i> -->
                <img src="@/assets/images/refund/组 1567.png" alt="" />
              </div>
              <div>卖家处理售后申请</div>
            </div>
            <img class="img1" src="@/assets/images/refund/组 1614.png" alt="" />
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-ziyuan38"></i> -->
                <img src="@/assets/images/refund/组 1609.png" alt="" />
              </div>
              <div class="finish">售后处理完毕</div>
            </div>
            <!-- <div>
              <div></div>
              <div>买家申请退货退货</div>
            </div>
            <img src="@/assets/images/orderDetails/success.png" alt="" />
            <div>
              <div></div>
              <div>买家申请退货退货</div>
            </div>
            <img src="@/assets/images/orderDetails/success.png" alt="" /> -->
          </div>
        </div>
        <!-- 详情 -->
        <div class="tk">
          <div class="testimony">
            <!-- 退货 -->
            <div class="dispose">
              <div
                class="btn"
                v-if="information.role == 2 && information.refundState == 1"
              >
                <div><span class="iconfont icon-daichuli"></span></div>
                <p>等待卖家处理......</p>
                <Button
                  class="consent"
                  :loading="loading"
                  :disabled="consentblack"
                  @click="consent1"
                  >同意</Button
                >
                <Button
                  class="repulse"
                  :loading="loadingju"
                  :disabled="refuseblack"
                  @click="refuse"
                  >拒绝</Button
                >
              </div>
              <div
                class="btn"
                v-if="information.role == 1 && information.refundState == 1"
              >
                <div><span class="iconfont icon-daichuli"></span></div>
                <p>等待卖家处理......</p>
                <Button
                  class="consent"
                  :loading="loadingcx"
                  :disabled="revocationblack"
                  @click="revocation"
                  >撤销申请</Button
                >
              </div>
            </div>
            <!-- 表单 -->
            <div class="Sheets">
              <Row>
                <Col span="5">
                  <span>服务类型 :</span>
                  <!-- <span>{{}}</span> -->
                  <!-- <span style="margin-left:5px">退货退货</span> -->
                  <span style="margin-left: 5px">{{
                    information.refundType == '3' ? '仅退款' : '退货退款'
                  }}</span>
                </Col>
                <Col span="12">
                  <span>原因 :</span>
                  <!-- <span style="margin-left:5px">厂家发货时间延误,不想要了</span> -->
                  <span style="margin-left: 5px">{{
                    information.content
                  }}</span>
                </Col>
              </Row>
              <!-- <Row>
                <Col span="12">
                  <span>退货说明 :</span>
                  <span style="margin-left:5px">厂家发货时间延误,不想要了</span>
                  <span style="margin-left:5px">{{ information.remark }}</span>
                </Col>
              </Row> -->
              <div class="explain">
                <div class="w64">退款说明 :</div>
                <div class="smcontent">
                  <span style="margin-left: 5px">{{ information.remark }}</span>
                </div>
              </div>
              <Row>
                <Col style="margin-top: 8px">
                  <div style="display: flex">
                    <div>上传凭证 :</div>
                    <ul>
                      <li v-viewer>
                        <img
                          v-for="item in voucherlist"
                          :key="item"
                          :src="item"
                          alt=""
                        />
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
            <!-- 表格 -->
            <div class="sheet">
              <span class="returns"> 退货商品:</span>
              <vxe-table
                border
                ref="xTable3"
                size="mini"
                align="center"
                resizable
                show-overflow
                :data="tableData3"
              >
                <vxe-column
                  field="partName"
                  title="退货商品"
                  width="220"
                ></vxe-column>
                <vxe-column field="partName" title="发货地" width="220">
                  <template #default="{ row }">
                    <span> {{ row.shipCity }}{{ row.shipStore }} </span>
                  </template>
                </vxe-column>
                <vxe-column
                  field="partNum"
                  title="购买数量"
                  width="100"
                ></vxe-column>
                <vxe-column
                  field="refundableAmount"
                  title="可退数量"
                  width="100"
                ></vxe-column>
                <vxe-column field="refundNumber" title="退货数量" width="120">
                </vxe-column>
                <vxe-column
                  field="refundPrice"
                  title="退货单价"
                  width="100"
                ></vxe-column>
                <vxe-column
                  field="refundAmount"
                  title="退货金额"
                  width="100"
                ></vxe-column>
              </vxe-table>
            </div>
          </div>

          <!-- 订单详情 -->
          <div class="indentparticulars">
            <div class="headline">
              <span>订单详情</span>
            </div>
            <div class="content">
              <div class="content_top">
                <Row>
                  <Col span="6">
                    <span>卖家 :&nbsp;</span>
                    <span>{{ particulars.buyShopName }}</span>
                    <span v-if="information.role == 1">
                      <xiaopei
                        :oppositeTenantId="particulars.buyTenantId"
                        :orderId="information.afterSaleId"
                      >
                        <i class="iconfont icon-a-lujing162"></i>
                      </xiaopei>
                    </span>
                  </Col>
                  <Col span="6">
                    <span>订单编号 :&nbsp;</span>
                    <span class="span1">
                      <router-link
                        rel="opener"
                        :to="{
                          path: '/orderDetails',
                          query: {
                            id: particulars.code,
                            orderId: particulars.id
                          }
                        }"
                        >{{ particulars.code }}</router-link
                      >
                    </span>
                  </Col>
                  <Col span="6">
                    <span>商品金额 :&nbsp;</span>
                    <span style="margin-left: 5px"
                      >&yen;{{ particulars.goodsAmount }}</span
                    >
                  </Col>
                </Row>

                <div style="margin-top: 33px; margin-bottom: 33px">
                  <Row>
                    <Col span="6">
                      <span>运费 :&nbsp;</span>
                      <span style="margin-left: 5px"
                        >&yen;{{
                          particulars.freight ? particulars.freight : 0
                        }}</span
                      >
                    </Col>

                    <Col span="6">
                      <span>实付款 :&nbsp;</span>
                      <span style="margin-left: 5px"
                        >&yen;{{ particulars.payMoney }}</span
                      >
                    </Col>
                    <Col span="6">
                      <span>数量 :&nbsp;</span>
                      <span style="margin-left: 5px">{{
                        particulars.count
                      }}</span>
                    </Col>
                  </Row>
                </div>
              </div>
              <div class="details">
                <div class="cleared">
                  <Row>
                    <Col span="6">
                      <span>退货单号 : &nbsp;</span>
                      <span style="margin-left: 5px">{{
                        refundindent.code
                      }}</span>
                    </Col>
                    <Col span="6">
                      <span>服务类型 :&nbsp;</span>
                      <span style="margin-left: 5px">{{
                        refundindent.type == '3' ? '仅退款' : '退货退款'
                      }}</span>
                    </Col>

                    <Col span="6">
                      <span>退货金额 :&nbsp;</span>
                      <span style="margin-left: 5px"
                        >&yen;{{ refundindent.goodsAmount }}</span
                      >
                    </Col>
                  </Row>
                  <Row style="margin-top: 40px">
                    <Col span="6">
                      <span>状态 :&nbsp;</span>
                      <span class="colorFF6">{{ information.orderState }}</span>
                    </Col>
                    <Col span="6">
                      <span>原因 :&nbsp;</span>
                      <span>{{ information.content }}</span>
                    </Col>
                    <Col span="6">
                      <span>退货数量 :&nbsp;</span>
                      <span>{{ refundindent.count }}</span>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 80px"></div>
  </div>
</template>

<script>
import headerTop from '@/views/base/common/header-top.vue'
import { disfreightInfo, buyerfreight, sellefreight } from '@/api/freight/index'
import xiaopei from '@/views/xiaopei/index.vue'
export default {
  components: {
    headerTop,
    xiaopei
  },
  props: {
    afterSaleId: String,
    refundType: String
  },
  data() {
    return {
      // examine: false,
      // 第二个表格数据
      tableData3: [
        // {
        //   id: 10001,
        //   partsName: '奔驰水箱散热器A1695001803', // 配件名称
        //   buyquantity: '购买数量', // 购买数量
        //   returnable: '可退数量', // 可退数量
        //   returns: '退货数量', // 退货数量
        //   returnsprice: '退货单价', // 退货单价
        //   returnsmoney: '退货金额' // 退货金额
        // }
      ],
      // 上传的凭证图片
      voucherlist: [],
      information: {}, // 原因
      refundindent: {}, // 退货订单
      particulars: {}, // 订单详情普通订单
      loading: false, // 同意的转圈
      loadingju: false, // 拒绝的转圈
      loadingcx: false, // 撤销的转圈
      consentblack: false, // 同意禁止
      refuseblack: false, // 拒绝禁止
      revocationblack: false // 撤销禁止
    }
  },
  created() {
    this.orderdata()
    // this.ceshi163()
  },
  methods: {
    ceshi163() {
      console.log(this.afterSaleId)
    },
    // 退货退货详情
    async orderdata() {
      console.log('---orderData:', this.afterSaleId)
      console.log('---orderData:', this.refundType)
      const res = await disfreightInfo(this.afterSaleId + '/' + this.refundType)
      console.log(res)
      this.information = res.data
      // this.$router.query = {}
      this.information.refundType = this.refundType
      this.voucherlist = res.data.imagesUrl
      this.tableData3 = res.data.ordersDetailVOList
      this.refundindent = res.data.refundOrderVO
      this.particulars = res.data.orderVO
      let path = this.$router.history.current.path
      this.$router.push({
        path,
        query: { drawback: this.afterSaleId, refundType: this.refundType }
      })
      console.log(this.$router.query)
    },
    // 撤销申请
    async revocation() {
      console.log(this.refundType)
      const res = await buyerfreight(this.afterSaleId + '/' + this.refundType)
      console.log(res)
      this.loadingcx = true
      this.consentblack = true
      this.refuseblack = true
      if (res.status) {
        this.loadingcx = false
        this.consentblack = false
        this.refuseblack = false
        // this.$emit('show2')
        // console.log(this.$router.query.refundType)
        res.refundType = this.refundType
        this.$emit('show4', res)
        this.$Message.success('撤销成功')
      } else {
        this.loadingcx = false
        this.consentblack = false
        this.refuseblack = false
      }
    },
    // 同意退货
    async consent1() {
      this.loading = true
      this.refuseblack = true
      this.revocationblack = true
      const res = await sellefreight({
        afterSaleId: this.afterSaleId, //退货订单id
        state: 1,
        type: this.refundType
      })
      console.log(res)
      if (res.status) {
        this.loading = false
        this.refuseblack = false
        this.revocationblack = false
        this.$emit('show2', res.data)
      } else {
        this.loading = false
        this.refuseblack = false
        this.revocationblack = false
      }
    },
    //拒绝退货
    async refuse() {
      this.loadingju = true
      this.consentblack = true
      this.revocationblack = true
      const res = await sellefreight({
        afterSaleId: this.afterSaleId, //退货订单id
        state: 0,
        type: this.refundType
      })
      console.log(res)
      if (res.status) {
        // this.$emit('show2')
        this.loadingju = false
        this.consentblack = false
        this.revocationblack = false
        this.$emit('show3', res.data)
      } else {
        this.loadingju = false
        this.consentblack = false
        this.revocationblack = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
